export default __webpack_public_path__ + "static/media/error-de-validacion.2b59effc.svg";